import type { Options } from "../types";
import { download } from "../utils";

export const plain = (content: string, options: Options) => {
  download(content, options, "text/plain");
};
